import { render, staticRenderFns } from "./updateitem.vue?vue&type=template&id=ad5b8ecc&scoped=true&"
import script from "./updateitem.vue?vue&type=script&lang=js&"
export * from "./updateitem.vue?vue&type=script&lang=js&"
import style0 from "./updateitem.vue?vue&type=style&index=0&id=ad5b8ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5b8ecc",
  null
  
)

export default component.exports